import React from 'react';

function DiscountPopup({ open, onClose, cart, slabData, t }) {
    if (!open) {
        return null;
    }

    const formatToCurrency = (price) => {
        if (!price || isNaN(price)) return '0.00';
        return parseFloat(price).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return (
        <div className="discount-popup-overlay" onClick={onClose}>
            <div className="discount-popup-content" onClick={(e) => e.stopPropagation()}>
                <div className="discount-popup-header">
                    <h2>{t('Discount Tiers')}</h2>
                    <button className="discount-popup-close" onClick={onClose}>&times;</button>
                </div>
                <div className="discount-popup-body">
                    {slabData && slabData.length > 0 ? (
                        <ul className="discount-list">
                            {slabData.map((slab, index) => (
                                <li key={index} className="discount-item">
                                    <span className="discount-item-name">{t('Spend over')} ฿{formatToCurrency(slab.slab_total)}</span>
                                    <span className="discount-item-amount">{t('Get')} ฿{formatToCurrency(slab.slab_discnt)} {t('off')}</span>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>{t('No discount tiers available.')}</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default DiscountPopup;
